export function ErrorBanner({
  message,
  onRetry,
}: {
  message: string;
  onRetry?: () => void;
}) {
  return (
    <div className="lk-widget-error">
      <span>{message}</span>
      {onRetry && (
        <button type="button" className="lk-widget-error-retry" onClick={onRetry}>
          Retry
        </button>
      )}
    </div>
  );
}
